module.exports = __webpack_public_path__ + "static/media/p1.3527fe86.svg";